import { defineMessages } from 'react-intl';

export const scope = 'app.components.pages.NewLogin';

export default defineMessages({
  welcomeToCapillary: {
    id: `${scope}.welcomeToCapillary`,
    defaultMessage: 'Welcome to Capillary',
  },
  welcomeBack: {
    id: `${scope}.welcomeBack`,
    defaultMessage: 'Welcome back',
  },
  signInToYourAccount: {
    id: `${scope}.signInToYourAccount`,
    defaultMessage: 'Sign in to your account',
  },
  usernamePlaceholder: {
    id: `${scope}.usernamePlaceholder`,
    defaultMessage: 'Enter your email address',
  },
  usernamePassRequired: {
    id: `${scope}.usernamePassRequired`,
    defaultMessage: 'Please enter your username and password',
  },
  passwordPlaceholder: {
    id: `${scope}.passwordPlaceholder`,
    defaultMessage: 'Enter a password',
  },
  continueButton: {
    id: `${scope}.continueButton`,
    defaultMessage: 'Continue',
  },
  signInButton: {
    id: `${scope}.signInButton`,
    defaultMessage: 'Sign in',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Back',
  },
  passwordIncorrect: {
    id: `${scope}.passwordIncorrect`,
    defaultMessage: 'The password you entered is incorrect',
  },
  checkingAuthentication: {             
    id: `${scope}.checkingAuthentication`,
    defaultMessage: 'Checking...',
  },
  backToEmail: {                       
    id: `${scope}.backToEmail`,
    defaultMessage: 'Use different email',
  },
  changeEmail: {
    id: `${scope}.changeEmail`,
    defaultMessage: 'Change email',
  },
  verifyButton: {
    id: `${scope}.verifyButton`,
    defaultMessage: 'Verify',
  },
  or: {
    id: `${scope}.or`,
    defaultMessage: 'OR',
  },
  signInWithGoogle: {
    id: `${scope}.signInWithGoogle`,
    defaultMessage: 'Sign in with Google',
  },
  verifyYourAccount: {
    id: `${scope}.verifyYourAccount`,
    defaultMessage: 'Verify Your Account',
  },
  otpDescription: {
    id: `${scope}.otpDescription`,
    defaultMessage: 'Enter the 6-character verification code sent to your registered email or phone number',
  },
  didntReceiveCode: {
    id: `${scope}.didntReceiveCode`,
    defaultMessage: "Didn't receive the code?",
  },
  resendOTP: {
    id: `${scope}.resendOTP`,
    defaultMessage: 'Resend OTP',
  },
  resending: {
    id: `${scope}.resending`,
    defaultMessage: 'Resending...',
  },
  otpResentSuccess: {
    id: `${scope}.otpResentSuccess`,
    defaultMessage: 'OTP has been resent to mail',
  },
  twoFactorAuthentication: {
    id: `${scope}.twoFactorAuthentication`,
    defaultMessage: 'Two-factor authentication',
  },
  otpEmailDescription: {
    id: `${scope}.otpEmailDescription`,
    defaultMessage: 'Enter the One Time Passcode sent to {email}, valid for 1 minute. Check your spam folder once if you can\'t see the email in your inbox.',
  },
  code: {
    id: `${scope}.code`,
    defaultMessage: 'Code',
  },
  enterOTP: {
    id: `${scope}.enterOTP`,
    defaultMessage: 'Enter the 6 digit code',
  },
  resendIn: {
    id: `${scope}.resendIn`,
    defaultMessage: 'Resend in {seconds}s',
  },
  forgotPassword: {
    id: `${scope}.forgotPassword`,
    defaultMessage: 'Forgot password?',
  },
  resetYourPassword: {
    id: `${scope}.resetYourPassword`,
    defaultMessage: 'Forgot password?',
  },
  enterEmailDescription: {
    id: `${scope}.enterEmailDescription`,
    defaultMessage: 'We\'ll send a link to your email with easy steps to reset your password.',
  },
  emailAddress: {
    id: `${scope}.emailAddress`,
    defaultMessage: 'Email address',
  },
  emailPlaceholder: {
    id: `${scope}.emailPlaceholder`,
    defaultMessage: 'Enter your email address',
  },
  enterEmailAddress: {
    id: `${scope}.enterEmailAddress`,
    defaultMessage: 'Enter email address',
  },
  sendResetLink: {
    id: `${scope}.sendResetLink`,
    defaultMessage: 'Send reset link',
  },
  backToLogin: {
    id: `${scope}.backToLogin`,
    defaultMessage: 'Back to login',
  },
  checkYourEmail: {
    id: `${scope}.checkYourEmail`,
    defaultMessage: 'Check your email',
  },
  resetInstructions: {
    id: `${scope}.resetInstructions`,
    defaultMessage: "If an account exists for {email}, you'll receive a link to reset your password.",
  },
  didntReceiveEmail: {
    id: `${scope}.didntReceiveEmail`,
    defaultMessage: 'Didn\'t receive the email?',
  },
  clickToResend: {
    id: `${scope}.clickToResend`,
    defaultMessage: 'Click to resend',
  },
  contactAdmin: {
    id: `${scope}.contactAdmin`,
    defaultMessage: 'Contact your administrator if you\'re facing trouble receiving the email',
  },
  contactAdminToUnlock: {
    id: `${scope}.contactAdminToUnlock`,
    defaultMessage: 'Please contact your admin to unlock your account.',
  },
  tryAgain: {
    id: `${scope}.tryAgain`,
    defaultMessage: 'try again',
  },
  newPassword: {
    id: `${scope}.newPassword`,
    defaultMessage: 'New password',
  },
  newPasswordPlaceholder: {
    id: `${scope}.newPasswordPlaceholder`,
    defaultMessage: 'Enter a new password',
  },
  confirmPassword: {
    id: `${scope}.confirmPassword`,
    defaultMessage: 'Confirm password',
  },
  confirmNewPassword: {
    id: `${scope}.confirmNewPassword`,
    defaultMessage: 'Confirm new password',
  },
  confirmPasswordPlaceholder: {
    id: `${scope}.confirmPasswordPlaceholder`,
    defaultMessage: 'Confirm new password',
  },
  confirmNewPasswordPlaceholder: {
    id: `${scope}.confirmNewPasswordPlaceholder`,
    defaultMessage: 'Confirm the new password',
  },
  setPassword: {
    id: `${scope}.setPassword`,
    defaultMessage: 'Set password',
  },
  resetPassword: {
    id: `${scope}.resetPassword`,
    defaultMessage: 'Reset password',
  },
  resetPasswordDescription: {
    id: `${scope}.resetPasswordDescription`,
    defaultMessage: 'Reset your password for your account',
  },
  passwordRequired: {
    id: `${scope}.passwordRequired`,
    defaultMessage: 'Please enter a password',
  },
  confirmPasswordRequired: {
    id: `${scope}.confirmPasswordRequired`,
    defaultMessage: 'Please confirm your password',
  },
  passwordsDoNotMatch: {
    id: `${scope}.passwordsDoNotMatch`,
    defaultMessage: 'Passwords don\'t match',
  },
  emailRequired: {
    id: `${scope}.emailRequired`,
    defaultMessage: 'Please enter your email address',
  },
  emailInvalid: {
    id: `${scope}.emailInvalid`,
    defaultMessage: 'Enter a valid email address',
  },
  hiUserName: {
    id: `${scope}.hiUserName`,
    defaultMessage: 'Hi {userName}',
  },
  setupPasswordDescription: {
    id: `${scope}.setupPasswordDescription`,
    defaultMessage: 'Setup a password for your account',
  },
  password: {
    id: `${scope}.password`,
    defaultMessage: 'Password',
  },
  enterPassword: {
    id: `${scope}.enterPassword`,
    defaultMessage: 'Enter a password',
  },
  confirmThePassword: {
    id: `${scope}.confirmThePassword`,
    defaultMessage: 'Confirm the password',
  },
  atLeast12Characters: {
    id: `${scope}.atLeast12Characters`,
    defaultMessage: 'At least 12 characters',
  },
  cannotContainNameOrEmail: {
    id: `${scope}.cannotContainNameOrEmail`,
    defaultMessage: 'Cannot contain name or email address',
  },
  atLeast1Uppercase: {
    id: `${scope}.atLeast1Uppercase`,
    defaultMessage: 'At least 1 uppercase',
  },
  atLeast1Number: {
    id: `${scope}.atLeast1Number`,
    defaultMessage: 'At least 1 number',
  },
  atLeast1SpecialCharacter: {
    id: `${scope}.atLeast1SpecialCharacter`,
    defaultMessage: 'At least 1 special character',
  },
  passwordRequirementsNotMet: {
    id: `${scope}.passwordRequirementsNotMet`,
    defaultMessage: 'Password must meet all requirements',
  },
  accountLockedTitle: {
    id: `${scope}.accountLockedTitle`,
    defaultMessage: 'Account locked temporarily',
  },
  wrongOTPMessage: {
    id: `${scope}.wrongOTPMessage`,
    defaultMessage: 'You\'ve entered the wrong OTP 5 times. For your security, your account is locked for 1 hour. Please try logging in again after that.',
  },
  wrongPasswordMessage: {
    id: `${scope}.wrongPasswordMessage`,
    defaultMessage: 'You\'ve entered the wrong password 5 times. For your security, your account is locked for 1 hour. Please try logging in again after that.',
  },
  emailResentSuccess: {
    id: `${scope}.emailResentSuccess`,
    defaultMessage: 'Email has been resent',
  },
  passwordResetSuccessTitle: {
    id: `${scope}.passwordResetSuccessTitle`,
    defaultMessage: 'Password has been reset!',
  },
  passwordCreatedSuccessTitle: {
    id: `${scope}.passwordCreatedSuccessTitle`,
    defaultMessage: 'Password has been created!',
  },
  redirectingToLogin: {
    id: `${scope}.redirectingToLogin`,
    defaultMessage: 'Redirecting you to the login page in',
  },
  logInButton: {
    id: `${scope}.logInButton`,
    defaultMessage: 'Log in',
  },
});
